<template>
  <Container type="card-full">
    <!-- <div slot="header">
      <menu-btn :menuid="menuid" @btnClick="btnClick"></menu-btn>
    </div> -->
    <vgtree ref="xTree" :list="list" tableheight="700" flexname="" :cols="cols" :showfooter="false"
            :showPage="true" :resizable="true" :total="query.total"
            :needRowNum="true" :needBlackRow="false" :needPopMenu="true" :canbeEdit="true"
            @cellClick="cellClick" @getxTree="getxTree">
          <template slot="btn">
              <menu-btn :menuid="menuid" @btnClick="btnClick"></menu-btn>
          </template>
    </vgtree>
    <el-dialog :title="addOrInsertFlg === 1 ? '新增' : '插入下级分类'" :visible.sync="doctflowform">
      <el-form class="small-space" :model="form" label-position="left" label-width="120px" style='width: 400px; margin-left:50px;'>
        <el-form-item label="顺序号" required>
          <el-input v-model="form.doctflowseq"></el-input>
        </el-form-item>
        <el-form-item label="审核名称" required>
          <el-input v-model="form.doctflowname" ></el-input>
        </el-form-item>
        <el-form-item label="审核后状态" required>
          <el-input v-model="form.doctflowstatusname" ></el-input>
        </el-form-item>
        <el-form-item label="审核角色" required>
          <el-select v-model="form.doctflowroleid" :clearable="true">
            <el-option v-for="(item, index) in roleList" :label="item.rolename" :value="item.roleid" :key="index"></el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <div slot="footer">
        <el-button type="primary" @click="save">保存</el-button>
        <el-button @click="doctflowform = false">关闭</el-button>
      </div>
    </el-dialog>
  </Container>
</template>
<script>
  import request from  '@/utils/request'
  import MenuBtn from "../common/menuBtn"
  import vgtree from '../common/vgtree'
  import utils from '../../assets/js/utils'
  export default {
    name: 'doctFlowIndex',
    data () {
      return {
        menuid: this.$route.query.menuid,
        list: [],
        roleList: [],
        cols: [
          { type: 'index',fieldtype: 'I', title: '行号',calculExpr:'', width: 80},
          { field: 'doctname', fieldtype: 'C', title: '单据分类',calculExpr:'', addNewRowFlg: false},
          { field: 'doctflowseq', fieldtype: 'B', title: '审核顺序',calculExpr:'',addNewRowFlg: false,editRender: { name: 'input'}},
          { field: 'doctflowname', fieldtype: 'C',title: '审核名称',calculExpr:'',addNewRowFlg: false,editRender: { name: 'input'}},
          { field: 'doctflowstatusname', fieldtype: 'C',title: '审核后状态',calculExpr:'',addNewRowFlg: false,editRender: { name: 'input'}},
          { field: 'doctflowroleid', fieldtype: 'L',title: '审核角色',calculExpr:'',addNewRowFlg: false,editRender: { name: 'ElSelect', options: []}}
        ],
        doctflowform: false,
        xTree: {},
        doctflow: {},
        form: {},
        addOrInsertFlg: 1,
        query: {
          comid: this.$store.getters.loginUser.usercomid,
          total: 0,
          currPage: 1,
          pageSize: 20
        }
      }
    },
    beforeCreate () {
    },
    created () {
      this.$on('INS', () => this.insertDoctFlow())
      this.$on('SAV', () => this.saveDoctFlow())
      this.$on('DEL', () => this.delDoctFlow())
      this.$on('OPEN', () => this.openDoctFlow())
      this.$on('PACKUP', () => this.packupDoctFlow())
      this.$on('CLOSE', () => this.close())
    },
    activated() {
      this.getRoleList()
      this.getPageList()
    },
    mounted () {
    },
    components: {MenuBtn,vgtree},
    methods: {
      btnClick (code) {
        this.$emit(code)
      },
      async close() {
        this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: ''})
      },
      async getRoleList () {
        this.roleList = await request({
          url: '/xtgl/role/getRoleList',
          method: "get",
          params: {comid: this.$store.getters.loginUser.usercomid}
        })
        this.cols[5].editRender.options = this.roleList
      },
      async insertDoctFlow () {
        if (this.doctflow.doctflowdoctid !== 0) {
          this.$message.warning('请选择需要单据分类的行!')
          return
        }
        let maxseq = 0
        this.doctflow.children.forEach(item => {
          if (item.doctflowseq>maxseq) {
            maxseq = item.doctflowseq
          }
        })
        this.form = this.doctflow
        this.form.doctflowdoctid = this.doctflow.doctid
        this.form.doctflowname = '',
        this.form.doctflowstatusname = '',
        this.form.doctflowseq = Number(maxseq) + 1
        this.form.doctflowcomid = this.$store.getters.loginUser.usercomid
        this.doctflowform = true
      },
      async packupDoctFlow () {
        this.$refs.xTree.$refs.xTree.clearTreeExpand()
      },
      async openDoctFlow () {
        this.$refs.xTree.$refs.xTree.setAllTreeExpansion(true)
      },
      async delDoctFlow () {
        if (this.doctflow.doctflowdoctid === 0) {
          this.$message.warning('请选择一条单据分类流程数据!')
          return
        }
        this.$confirm('确定删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          let data = await request({
            url: '/xtgl/doctflow/delDoctFlow',
            method: "post",
            data: this.doctflow
          })
          if (data.issuccess===1) {
            this.getPageList()
            this.$message.success('删除成功！')
          } else {
            this.$message.error(data.msg)
          }
        })
      },
      async save () {
        let model = {
          insertRecords: [this.form],
          updateRecords: [],
          removeRecords: []
        }
        await this.addOrEdit(model)
        this.doctflowform = false
      },
      async saveDoctFlow () {
        let model = this.$refs.xTree.$refs.xTree.getRecordset()
        this.addOrEdit(model)
      },
      async addOrEdit (model) {
        if (model.insertRecords.length===0 && model.updateRecords.length === 0 && model.removeRecords.length ===0) {
          this.$message.warning('数据没有修改，不需要保存')
          return
        }
        let data = await request({
          url: '/xtgl/doctflow/addOrEdit',
          method: "post",
          data: model
        })
        if (data.issuccess===1) {
          this.getPageList()
          this.$message.success('保存成功')
        } else {
          this.$message.error('保存失败')
        }
      },
      async getxTree(xtree) {
        this.xTree = xtree
      },
      async cellClick (row) {
        this.doctflow = row.row
      },
      async getPageList () {
        this.loading = true
        let res = await request({
          method: 'get',
          url: '/xtgl/doctflow/getPageList',
          params: this.query
        })
        this.list = res
        this.loading = false
      }
    },
    filters: {
      num (val) {
        return Number(val)
      }
    }
  }
</script>
<style lang="scss">

</style>
